module.exports = __webpack_public_path__ + "assets/img/download.fbd5d064.png";